(ns app.front.view.group.reporting.statcan-occupancy
  "StatCan residential building occupancy report."
  (:require [app.front.ui.radio :as ui-radio]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.download-button :as rdb]
            [app.front.view.group.reporting.list :as report-list]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [reagent.core :as r]
            [schema.core :as s]))

(def date-type-values [:occupancy :workspace-finish])

(defn view [match]
  (r/with-let [*params    (r/atom (reporting-common/current-year-month true))
               *date-type (r/atom nil)]
    (let [tr        (<sub [::gas/group-tr])
          group-id  (<sub [::gas/group-id])
          date-type @*date-type]
      [reporting-common/report-page
       match
       tr
       [:section
        [reporting-common/month-select-with-button
         (util/mmap {:title     [:<>
                                 [:h3.mb-4 (tr [:reporting.statcan/building-and-demolition-permits])]
                                 [:h4 (tr [:reporting.statcan/residential-building-occupancy])]]
                     :on-change (fn [month year]
                                  (reset! *params (util/mmap month year)))}
                    tr)]
        [:div.lg:p-4.mt-4
         [ui-radio/radio
          {:name       "statcan-occupancy-date-type"
           :label-text (tr [:reporting.statcan/date-type-label])
           :required   true
           :values     date-type-values
           :value      date-type
           :val->str   (fn [v] (tr [(keyword "reporting.statcan" (str "date-type-" (name v)))]))
           :on-change  #(reset! *date-type %)}]]
        [:div.lg:p-4.mt-4
         [rdb/generate-button (util/mmap {:query    (merge {:group-id    group-id
                                                            :report-type :reporting/statcan-occupancy-report
                                                            :date-type   date-type}
                                                           @*params)
                                          :disabled (nil? date-type)}
                                         tr)]]
        [report-list/list-section (util/mmap {:report-type :reporting/statcan-occupancy-report} tr)]]])))


(def route
  {:name        :view/group.reporting.statcan-occupancy
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::reporting-common/fetch-reports group-id])
                                  (>evt [::reporting-common/fetch-group group-id])))}]})
